import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import "./MobMap.css";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import { useAuthStudent } from "../../../context/StudentLoginContext/StudentAuthContext";
import { usePreviewQuests } from "../../../../hooks/web/usePreviewQuests";
import { useGetQuests } from "../../../../hooks/student/quest/useGetQuests";
import { useI18nLoader } from "../../../i18n/loaders/useI18nLoader";
import { loadStudentMapI18n } from "../../../i18n/loaders/student.i18n";
import { useTranslation } from "react-i18next";
import { AuthModal } from "../../../common/AuthV2/AuthModal";
import NavigateToAddStudentPopup from "../../../common/AuthV2/NavigateToAddStudentPopup";

export const MobileMap = () => {
  const { t } = useTranslation("student-map");
  const navigate = useNavigate();
  const { user } = useAuth();
  const { student } = useAuthStudent();
  const currentUser = user?.user || student?.student;
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalView, setAuthModalView] = useState("options");
  const [selectedQuestId, setSelectedQuestId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  const [selectedQuestImage, setSelectedQuestImage] = useState(null);
  const i18nReady = useI18nLoader(loadStudentMapI18n);
  const { userType } = useOutletContext();
  const { fetchPreview, data, loading, error: newError } = usePreviewQuests();
  const { quests, error, getQuests } = useGetQuests();
  const isQuestAssigned = (questId) => {
    const quest = quests.find((q) => q.id === questId);
    return quest?.student_assigned && quest?.school_assigned;
  };
  const isAssignedBhagat = isQuestAssigned(1);
  const isAssignedGandhi = isQuestAssigned(6);
  const isAssignedShiva = isQuestAssigned(11);
  const isAssignedHanuman = isQuestAssigned(5);
  const isAssignedKrishna = isQuestAssigned(3);
  const isAssignedMurugan = isQuestAssigned(2);
  const isAssignedQueenJhansi = isQuestAssigned(7);
  const isAssignedRiseMaratha = isQuestAssigned(8);
  const isAssignedNetaji = isQuestAssigned(9);
  const isAssignedParshuram = isQuestAssigned(4);

  // const QUEST_ICONS = {
  //   1: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-icn.png",
  //   2: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-icn.png",
  //   3: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-icn.png",
  //   4: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-icn.png",
  //   5: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-icn.png",
  //   6: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-icn.png",
  //   7: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-icn.png",
  //   8: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-icn.png",
  //   9: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-icn.png",
  //   11: "https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiva-icn.png",
  // };
  const isSubscribed =
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed;

  const getPreviewById = (id) => {
    return data.find((item) => item.id === id);
  };

  const shouldShowLock = (id) => {
    if (loading) return false;

    const item = getPreviewById(id);

    if (!item) return true;

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    if (isSubscribed) return false;

    return !item.has_free_preview;
  };

  const handleQuestClick = (e, questId) => {
    e.preventDefault();

    if (loading || !data.length) {
      return; // or show loader / toast
    }

    const item = getPreviewById(questId);
    const isFree = item?.has_free_preview;

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    // const questImage = QUEST_ICONS[questId];

    if (!currentUser) {
      localStorage.setItem(
        "redirectAfterLogin",
        JSON.stringify({
          questId: questId,
          isFree: isFree ?? false,
          isSubscribed: isSubscribed ?? false,
        }),
      );

      setAuthModalView("options");
      setShowAuthModal(true);
      return;
    }

    if (!isFree && !isSubscribed) {
      setSelectedQuestId(questId);
      // setSelectedQuestImage(questImage);
      setShowAddStudentModal(true);
      return;
    }

    navigate(`/student/admin/episodes/${questId}`);
  };

  useEffect(() => {
    if (userType === "school-student") {
      getQuests("quest");
    }
  }, []);

  useEffect(() => {
    fetchPreview("quest"); // or "festive"
  }, []);

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  if (!i18nReady) return null; // or loader

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="text-center mt-4">
          <p className="QuestMapCard-Titl">
            Explore the map & begin your journey
          </p>
          <p className="QuestMapCard-Para">
            Discover Hidden Stories Across Time & Traditions!
          </p>
        </div>
      </div>
      <div className="col-md-12">
        <div className="QuestMapCardMF">
          <div className="QuestMobMapShiv">
            <img
              className="img-fluid"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/mobMap/shiv.png"
              alt=""
            />
            {userType === "school-student" ? (
              <Link to={isAssignedShiva ? "/student/admin/episodes/11" : "#"}>
                <img
                  className={`img-fluid QuestMapMobShivName zoom-in-zoom-out ${
                    isAssignedShiva ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiv-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMapMobShivIcn ${
                    isAssignedShiva ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiva-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/11"
                onClick={(e) => handleQuestClick(e, 11)}
              >
                <img
                  className={`img-fluid QuestMapMobShivName zoom-in-zoom-out`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiv-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMapMobShivIcn ${
                    shouldShowLock(11) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shiva-icn.png"
                  alt=""
                />
                {shouldShowLock(11) && (
                  <img
                    className="QuestMapMobShivIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>
          <div className="QuestMobMapHanuman">
            <img
              className="img-fluid"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/mobMap/hanuman.png"
              alt=""
            />
            {userType === "school-student" ? (
              <Link to={isAssignedHanuman ? "/student/admin/episodes/5" : "#"}>
                <img
                  className={`img-fluid QuestMobMapHanumanName zoom-in-zoom-out ${
                    isAssignedHanuman ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapHanumanIcn ${
                    isAssignedHanuman ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/5"
                onClick={(e) => handleQuestClick(e, 5)}
              >
                <img
                  className="img-fluid QuestMobMapHanumanName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapHanumanIcn ${
                    shouldShowLock(5) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/hanuman-icn.png"
                  alt=""
                />
                {shouldShowLock(5) && (
                  <img
                    className="QuestMapMobHanumanIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="QuestMobMapParshuram">
            <img
              className="img-fluid"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/mobMap/parshuram.png"
              alt=""
            />
            {userType === "school-student" ? (
              <Link
                to={isAssignedParshuram ? "/student/admin/episodes/4" : "#"}
              >
                <img
                  className={`img-fluid QuestMobMapParshuramName zoom-in-zoom-out ${
                    isAssignedParshuram ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapParshuramIcn ${
                    isAssignedParshuram ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/4"
                onClick={(e) => handleQuestClick(e, 4)}
              >
                <img
                  className="img-fluid QuestMobMapParshuramName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapParshuramIcn ${
                    shouldShowLock(4) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/parshuram-icn.png"
                  alt=""
                />
                {shouldShowLock(4) && (
                  <img
                    className="QuestMapMobParshuramIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="QuestMobMapBhagatSingh">
            <img
              className="img-fluid"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/mobMap/bhagat-singh.png"
              alt=""
            />
            {userType === "school-student" ? (
              <Link to={isAssignedBhagat ? "/student/admin/episodes/1" : "#"}>
                <img
                  className={`img-fluid QuestMobMapBhagatSinghName zoom-in-zoom-out ${
                    isAssignedBhagat ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapBhagatSinghIcn ${
                    isAssignedBhagat ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/1"
                onClick={(e) => handleQuestClick(e, 1)}
              >
                <img
                  className="img-fluid QuestMobMapBhagatSinghName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapBhagatSinghIcn ${
                    shouldShowLock(1) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bhagat-singh-icn.png"
                  alt=""
                />
                {shouldShowLock(1) && (
                  <img
                    className="QuestMapMobBhagatSinghIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="QuestMobMapMaratha">
            <img
              className="img-fluid"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/mobMap/maratha.png"
              alt=""
            />
            {userType === "school-student" ? (
              <Link
                to={isAssignedRiseMaratha ? "/student/admin/episodes/8" : "#"}
              >
                <img
                  className={`img-fluid QuestMapMobShivajiName zoom-in-zoom-out ${
                    isAssignedRiseMaratha ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapShivajiIcn ${
                    isAssignedRiseMaratha ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/8"
                onClick={(e) => handleQuestClick(e, 8)}
              >
                <img
                  className="img-fluid QuestMapMobShivajiName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapShivajiIcn ${
                    shouldShowLock(8) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/shivaji-icn.png"
                  alt=""
                />
                {shouldShowLock(8) && (
                  <img
                    className="QuestMapMobShivajiIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}

            {userType === "school-student" ? (
              <Link
                to={isAssignedQueenJhansi ? "/student/admin/episodes/7" : "#"}
              >
                <img
                  className={`img-fluid QuestMobMapQueenName zoom-in-zoom-out ${
                    isAssignedQueenJhansi ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapQueenIcn ${
                    isAssignedQueenJhansi ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/7"
                onClick={(e) => handleQuestClick(e, 7)}
              >
                <img
                  className="img-fluid QuestMobMapQueenName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapQueenIcn ${
                    shouldShowLock(7) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/queen-icn.png"
                  alt=""
                />
                {shouldShowLock(7) && (
                  <img
                    className="QuestMobMapQueenIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="QuestMobMapGandhi">
            <img
              className="img-fluid"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/mobMap/gandhi.png"
              alt=""
            />
            {/* {userType === "school-student" ? (
              <Link to={isAssignedGandhi ? "/student/admin/episodes/6" : "#"}>
                <img
                  className={`img-fluid QuestMobMapGandhiName zoom-in-zoom-out ${
                    isAssignedGandhi ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapGandhiIcn ${
                    isAssignedGandhi ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link to="/student/admin/episodes/6">
                <img
                  className="img-fluid QuestMobMapGandhiName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-name.png"
                  alt=""
                />
                <img
                  className="img-fluid QuestMobMapGandhiIcn"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/gandhi-icn.png"
                  alt=""
                />
              </Link>
            )} */}

            {userType === "school-student" ? (
              <Link to={isAssignedNetaji ? "/student/admin/episodes/9" : "#"}>
                <img
                  className={`img-fluid QuestMobMapBoseName zoom-in-zoom-out ${
                    isAssignedNetaji ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapBoseIcn  ${
                    isAssignedNetaji ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/9"
                onClick={(e) => handleQuestClick(e, 9)}
              >
                <img
                  className="img-fluid QuestMobMapBoseName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapBoseIcn ${
                    shouldShowLock(9) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/bose-icn.png"
                  alt=""
                />
                {shouldShowLock(9) && (
                  <img
                    className="QuestMobMapBoseIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="QuestMobMapKrishna">
            <img
              className="img-fluid"
              src="https://d2lvj32mp5x83n.cloudfront.net/static/mobMap/krishna.png"
              alt=""
            />
            {userType === "school-student" ? (
              <Link to={isAssignedKrishna ? "/student/admin/episodes/3" : "#"}>
                <img
                  className={`img-fluid QuestMobMapKrishnaName zoom-in-zoom-out ${
                    isAssignedKrishna ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapKrishnaIcn ${
                    isAssignedKrishna ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/3"
                onClick={(e) => handleQuestClick(e, 3)}
              >
                <img
                  className="img-fluid QuestMobMapKrishnaName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapKrishnaIcn ${
                    shouldShowLock(3) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/krishna-icn.png"
                  alt=""
                />
                {shouldShowLock(3) && (
                  <img
                    className="QuestMobMapKrishnaIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}

            {userType === "school-student" ? (
              <Link to={isAssignedMurugan ? "/student/admin/episodes/2" : "#"}>
                <img
                  className={`img-fluid QuestMobMruganName zoom-in-zoom-out ${
                    isAssignedMurugan ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapMruganIcn ${
                    isAssignedMurugan ? "" : "grayscale"
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-icn.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/2"
                onClick={(e) => handleQuestClick(e, 2)}
              >
                <img
                  className="img-fluid QuestMobMruganName zoom-in-zoom-out"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-name.png"
                  alt=""
                />
                <img
                  className={`img-fluid QuestMobMapMruganIcn ${
                    shouldShowLock(2) ? "blackgrayscale" : ""
                  }`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/murugan-icn.png"
                  alt=""
                />
                {shouldShowLock(2) && (
                  <img
                    className="QuestMobMapMruganIcnLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>
        </div>
      </div>
      {/* Login Modal */}
      <AuthModal
        show={showAuthModal}
        onHide={() => setShowAuthModal(false)}
        defaultView={authModalView}
      />

      {/* NavigateToAddStudentPopup Modal */}
      <NavigateToAddStudentPopup
        modalTitle="Continue to Unlock!"
        showModal={showAddStudentModal}
        handleClose={() => setShowAddStudentModal(false)}
        questImage={selectedQuestImage}
      />
    </div>
  );
};
